import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

export default styled(Flex).attrs({
  align: 'center',
  padding: '5px 15px',
})`
  color: #fff;
  font-size: 15px;
  border-radius: 25px;
  cursor: pointer;
  white-space: nowrap;
  background-color: ${props => props.theme.colors.tag};
  margin-bottom: 6px;
`;
